<template>
	<el-dialog title="收银台" :append-to-body="true" :visible.sync="centerDialogVisible" width="60%" center @close="onClose">
		<div class="dialog-content">
			<div class="top">
				<el-steps :active="['pay_before','pay_ing','pay_after'].indexOf(step)" finish-status="success"
					process-status="finish" simple>
					<el-step title="确认信息"></el-step>
					<el-step title="扫码支付"></el-step>
					<el-step title="支付结果"></el-step>
				</el-steps>
			</div>
			<div class="content">
				<div class="payBefore" v-if="step=='pay_before'">
					<div class="orderInfo" v-if="orderDetail.detail&&orderDetail.detail.length">
						<div v-for="e in orderDetail.detail" :key="e.course_id">
							<div class="pro" v-if="e&&e.course">
								<img :src="e.course.thumb_image"></img>
								<div class="right">
									<span>{{e.course.title}}</span>
									<span>￥{{Price(e.price,2)}}</span>
								</div>
							</div>
							<div class="pro" v-else-if="e&&e.special">
								<img :src="e.special.image"></img>
								<div class="right">
									<span>{{e.special.name}}</span>
									<span>￥{{Price(e.price,2)}}</span>
								</div>
							</div>
							<div class="pro" v-else>
								<img src="@/assets/placeholder.jpg"></img>
								<div class="right">
									<span>订单信息不完整</span>
									<span>￥**</span>
								</div>
							</div>
						</div>
					</div>
					<div class="cardInfo" v-if="orderDetail.card&&orderDetail.card.id">
						<div>
							<div class="card">
								<div class="left">
									<span>{{orderDetail.card.name}}</span>
									<span>{{orderDetail.card.remark}}</span>
								</div>
								<div class="right">
									<span>￥{{Price(orderDetail.card.price,2)}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="youhui" v-if="type=='order'">
						<div class="youhui-top">
							<p class="title">使用优惠</p>
							<div class="switch">
								<p :class="youhuiIndex == 0 ? 'checked' : ''" @click="youhuiIndexChange(0)">优惠券</p>
								<p :class="youhuiIndex == 1 ? 'checked' : ''" @click="youhuiIndexChange(1)">乐币</p>
							</div>
						</div>
						<div class="youhui-content">
							<div class="youhuiquan" v-if="youhuiIndex == 0">
								<div class="name">
									<p>优惠券</p>
									<p>共{{ coupon.length }}张</p>
								</div>
								<el-radio-group v-model="yhqIndex" @input="onPriceJisuan" v-if="coupon&&coupon.length">
									<el-radio class="lebiItem" :label="0">
										<div>
											<p style="color: #00b7ff">暂不使用</p>
											<p></p>
										</div>
									</el-radio>
									<el-radio class="lebiItem" v-for="(coup, index) in coupon" :key="coup.id" :label="index + 1">
										<div>
											<p style="color: #00b7ff">{{ coup.template.name }}</p>
											<p>抵扣</p>
											<p style="color: #00b7ff">{{ coup.template.discount_amount }}元</p>
										</div>
									</el-radio>
								</el-radio-group>
							</div>
							<div class="lebi" v-if="youhuiIndex == 1">
								<div class="name">
									<p>乐币</p>
									<p>共{{ $store.state.auth.score }}币</p>
								</div>
								<el-radio-group v-model="lebiIndex" @input="onPriceJisuan" v-if="$store.state.auth.score > 0">
									<el-radio class="lebiItem" :label="0">
										<div>
											<p style="color: #00b7ff">暂不使用</p>
											<p></p>
										</div>
									</el-radio>
									<el-radio class="lebiItem" :label="1" v-if="orderDetail.total_amount > $store.state.auth.score">
										<div>
											<p style="color: #00b7ff">全部使用</p>
											<p>抵扣</p>
											<p style="color: #00b7ff">{{ $store.state.auth.score }}元</p>
										</div>
									</el-radio>
									<el-radio class="lebiItem" :label="1" v-else>
										<div>
											<p style="color: #00b7ff">使用{{ (orderDetail.total_amount * 100) / 100 }}</p>
											<p>抵扣</p>
											<p style="color: #00b7ff">{{ orderDetail.total_amount }}元</p>
										</div>
									</el-radio>
									<el-radio class="lebiItem" :label="2">
										<div>
											<input class="input" placeholder-style="color:rgba(0,183,255,0.7)" type="number"
												placeholder="输入使用乐币数量" v-model="lebiNum" @focus="lebiNumFocus" @input="onPriceJisuan" />
											<p>抵扣</p>
											<p style="color: #00b7ff">{{ lebiNum || 0 }}元</p>
										</div>
									</el-radio>
								</el-radio-group>
							</div>
						</div>
					</div>
					<div class="shifu">
						<p>实付</p>
						<p>￥</p>
						<p>{{Price(needPay,2)}}</p>
					</div>
					<div class="btnBox">
						<el-button type="primary" class="cancelBtn" @click="onBeforeCancel">稍后支付</el-button>
						<el-button type="primary" class="confirmBtn" @click="onBeforePay">立即支付</el-button>
					</div>
				</div>

				<div class="payIng" v-if="step=='pay_ing'">
					<p> ─── 微信支付 安全便捷 ─── </p>
					<img :src="scanUrl" />
					<div class="scanStep">
						<p>1.打开微信"扫一扫"</p>
						<p>2.扫描上方二维码</p>
						<p>3.确认金额完成支付</p>
					</div>
					<div class="btnBox">
						<el-button type="primary" class="cancelBtn" @click="onIngCancel">上一步</el-button>
						<el-button type="primary" class="confirmBtn" @click="onIngCheck(true)">支付完成（{{checkTime}}s）</el-button>
					</div>
				</div>

				<div class="payAfter" v-if="step=='pay_after'">
					<div class="status">
						<i :class="['el-icon-warning','el-icon-success','el-icon-error'][this.payResult]"></i>
						<p :class="['text-warning','text-success','text-error'][this.payResult]">
							{{['未支付','支付成功','支付失败'][this.payResult]}}
						</p>
					</div>
					<div class="btnBox">
						<el-button type="primary" class="cancelBtn" @click="onAfterCancel">继续浏览</el-button>
						<el-button type="primary" class="confirmBtn" @click="onAfterSuccess">查看订单</el-button>
					</div>
				</div>

			</div>
		</div>
	</el-dialog>
</template>
<script>
	import QRCode from 'qrcode';
	export default {
		name: "cashierDialog",
		components: {},
		computed: {
			Price() {
				return (price, digit) => parseFloat(price).toFixed(digit || 0);
			}
		},
		data() {
			return {
				centerDialogVisible: false,
				step: 'pay_before', // pay_before,pay_ing，pay_after
				type: 'order', // order=课程订单,vip=会员卡订单
				order_id: '',

				orderDetail: {},
				needPay: 0,
				coupon: [],
				youhuiIndex: 0,
				lebiIndex: 0,
				lebiNum: 0,
				yhqIndex: 0,
				pay_user_coupon_id: '',
				pay_score: '',

				scanUrl: '',
				checkInterval: null,
				checkTime: 0,
				payResult: 0, // 0-待支付；1-支付成功；2-支付失败
			};
		},
		methods: {
			async onOpen(type, order_id) {
				this.type = type;
				this.order_id = order_id;
				await this.getUserInfo();
				if (this.type == 'order') await this.getOrderDetail();
				if (this.type == 'vip') await this.getVipOrderDetail();
				this.step = 'pay_before';
				this.centerDialogVisible = true;
			},
			onClose() {
				this.centerDialogVisible = false;
				if (this.checkInterval) clearInterval(this.checkInterval);
			},
			async getUserInfo() {
				const infoRes = await this.$zkHttp.user$getUserInfo();
				console.log("infoRes ===> ", infoRes);
				if (infoRes) {
					this.$store.commit("auth/setLoginInfo", {
						...infoRes,
					});
				}
			},
			async getVipOrderDetail() {
				const detailRes = await this.$zkHttp.order$get_card_orders_detail({
					id: this.order_id,
				});
				console.log("detailRes ===> ", detailRes);
				this.orderDetail = detailRes;
				this.needPay = this.orderDetail.amount;
			},
			async getOrderDetail() {
				const detailRes = await this.$zkHttp.order$get_order_detail({
					id: this.order_id,
				});
				console.log("detailRes ===> ", detailRes);
				this.orderDetail = detailRes;
				this.needPay = this.orderDetail.total_amount;
				await this.getCouponList();
			},
			async getCouponList() {
				let params = null;
				const orderInfo = this.orderDetail.detail[0];
				if (orderInfo.course_id) {
					params = {
						user_id: this.$store.state.auth.user_id,
						course_id: orderInfo.course_id,
						special_id: '',
					}
				}
				if (orderInfo.special_id) {
					params = {
						user_id: this.$store.state.auth.user_id,
						course_id: '',
						special_id: orderInfo.special_id,
					}
				}
				if (params) {
					const couponRes = await this.$zkHttp.user$getCouponList({
						...params
					});
					console.log("couponRes ===> ", couponRes);
					this.coupon = couponRes;
				}
			},
			youhuiIndexChange(val) {
				this.youhuiIndex = val;
				this.onPriceJisuan();
			},
			lebiNumFocus() {
				this.lebiIndex = 2;
				this.onPriceJisuan();
			},
			onPriceJisuan() {
				this.pay_user_coupon_id = '';
				this.pay_score = '';
				if (this.youhuiIndex == 0) {
					if (this.yhqIndex == 0) {
						this.needPay = this.orderDetail.total_amount;
					} else {
						this.needPay = (this.orderDetail.total_amount * 100 -
								this.coupon[this.yhqIndex - 1].template.discount_amount * 100) /
							100;
						this.pay_user_coupon_id = this.coupon[this.yhqIndex - 1].id;
					}
				}
				if (this.youhuiIndex == 1) {
					if (this.lebiIndex == 0) {
						this.needPay = this.orderDetail.total_amount;
					} else if (this.lebiIndex == 1) {
						if (this.$store.state.auth.score * 100 >= this.orderDetail.total_amount * 100) {
							this.needPay = 0;
							this.pay_score = this.orderDetail.total_amount * 100 / 100;
						} else {
							this.needPay = (this.orderDetail.total_amount * 100 -
									this.$store.state.auth.score * 100) /
								100;
							this.pay_score = this.$store.state.auth.score * 100 / 100;
						}
					} else if (this.lebiIndex == 2) {
						this.needPay = (this.orderDetail.total_amount * 100 -
								this.lebiNum * 100) /
							100;
						this.pay_score = this.lebiNum * 100 / 100;
					}
				}
			},
			onBeforeCancel() {
				this.onClose();
				if (this.type == 'order') {
					this.$message({
						showClose: true,
						message: "可以在'个人中心'-'我的订单'中再次发起支付！",
						duration: 3000,
						type: "info", // message type: success/warning/info/error
					});
				}
			},
			async onBeforePay() {
				if (!this.orderDetail.id) return;
				let payRes = null;
				if (this.type == 'order') {
					this.onPriceJisuan();
					payRes = await this.$zkHttp.order$payOrder({
						id: this.orderDetail.id,
						openid: this.$store.state.auth.openid,
						pay_type: 'scan', //支付类别:miniapp=小程序，wap=手机端网站，scan=扫码支付
						user_coupon_id: this.pay_user_coupon_id,
						score: this.pay_score
					});
				}
				if (this.type == 'vip') {
					payRes = await this.$zkHttp.order$payCardOrder({
						id: this.orderDetail.id,
						openid: this.$store.state.auth.openid,
						pay_type: 'scan', //支付类别:miniapp=小程序，wap=手机端网站，scan=扫码支付
					});
				}
				console.log("payRes ===> ", payRes);
				if (payRes && payRes.code_url) {
					this.generateQRCode(payRes.code_url);
				}
			},
			generateQRCode(url) {
				QRCode.toDataURL(url, {
					width: 200
				}, (err, url) => {
					if (err) throw err;
					this.scanUrl = url; // 获取Base64数据
					this.step = 'pay_ing';
				});
				this.checkTime = 120;
				this.checkInterval = setInterval(() => {
					this.checkTime--;
					if ((120 - this.checkTime) % 3 == 0) {
						this.onIngCheck(false);
					}
					if (this.checkTime == 0) {
						this.step = 'pay_after';
						this.payResult = 0;
						if (this.checkInterval) clearInterval(this.checkInterval);
					}
				}, 1000);
			},
			onIngCancel() {
				this.step = 'pay_before';
			},
			async onIngCheck(showMsg) {
				let order_type = '';
				if (this.type == 'order') order_type = 1;
				if (this.type == 'vip') order_type = 2;
				const statusRes = await this.$zkHttp.order$getOrderStatus({
					id: this.order_id,
					order_type,
				}, showMsg);
				console.log("statusRes ===> ", statusRes);
				if (statusRes) {
					this.step = 'pay_after';
					this.payResult = 1;
					if (this.checkInterval) clearInterval(this.checkInterval);
				}
			},
			onAfterSuccess() {
				this.$router.push(`/myOrder`);
			},
			onAfterCancel() {
				window.location.reload();
			},
		}
	}
</script>
<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	::v-deep .el-dialog {
		min-width: 720px;
		max-width: 800px;

		.el-dialog__header .el-dialog__title {
			font-weight: bold;
			letter-spacing: 4px;
		}

		.dialog-content {
			width: 100%;
			display: flex;
			flex-direction: column;

			.top {
				width: 100%;

				.el-steps--simple {
					margin: 0 auto;
					width: 60%;
					background: transparent;
				}
			}

			.content {
				margin-top: 20px;
				width: 100%;

				.payBefore {
					width: 100%;

					>.orderInfo {
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: center;

						>div {
							width: 100%;

							.pro {
								width: 100%;
								border: 1px solid #f4f4f4;
								border-radius: 10px;
								background: #f4f4f4;
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;

								>img {
									margin: 10px 20px;
									width: 60px;
									background: #f4f4f4;
								}

								>.right {
									width: calc(100% - 60px - 40px);
									display: flex;
									flex-direction: row;
									justify-content: space-between;
									align-items: center;

									>span:first-child {
										font-weight: 400;
										font-size: 16px;
										color: #666;
										overflow: hidden;
										text-overflow: ellipsis;
										display: -webkit-box;
										-webkit-line-clamp: 2;
										word-break: break-all;
										-webkit-box-orient: vertical;
									}

									>span:last-child {
										margin: 10px 20px;
										flex-shrink: 0;
										font-weight: 400;
										font-size: 20px;
										color: #ef0326;
									}
								}
							}
						}
					}

					.cardInfo {
						margin: 20px 0;
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: center;

						>div {
							width: 100%;

							.card {
								width: 100%;
								border: 1px solid #f4f4f4;
								border-radius: 10px;
								background: #f4f4f4;
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;

								.left {
									padding: 20px;
									display: flex;
									flex-direction: column;

									>span:first-child {
										font-weight: 400;
										font-size: 16px;
										color: #666;
										overflow: hidden;
										text-overflow: ellipsis;
										display: -webkit-box;
										-webkit-line-clamp: 2;
										word-break: break-all;
										-webkit-box-orient: vertical;
									}

									>span:last-child {
										font-weight: 400;
										font-size: 12px;
										color: #666;
										overflow: hidden;
										text-overflow: ellipsis;
										display: -webkit-box;
										-webkit-line-clamp: 2;
										word-break: break-all;
										-webkit-box-orient: vertical;
									}

								}

								.right {
									display: flex;
									flex-direction: row;
									justify-content: space-between;
									align-items: center;

									>span:first-child {
										font-weight: 400;
										font-size: 16px;
										color: #666;
										overflow: hidden;
										text-overflow: ellipsis;
										display: -webkit-box;
										-webkit-line-clamp: 2;
										word-break: break-all;
										-webkit-box-orient: vertical;
									}

									>span:last-child {
										margin: 10px 20px;
										flex-shrink: 0;
										font-weight: 400;
										font-size: 20px;
										color: #ef0326;
									}
								}
							}
						}


					}

					.youhui {
						padding: 20px 0;
						width: 100%;
						border-radius: 10px;

						.youhui-top {
							width: 100%;
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;

							>.title {
								font-weight: 400;
								font-size: 16px;
								color: #333;
							}

							>.switch {
								border-radius: 6px;
								border: 1px solid #00b7ff;
								display: flex;
								flex-direction: row;

								>p {
									display: block;
									width: 100px;
									border: 1px solid #00b7ff;
									font-weight: 400;
									font-size: 14px;
									color: #333;
									line-height: 24px;
									text-align: center;
								}

								>p:first-child {
									border-top-left-radius: 6px;
									border-bottom-left-radius: 6px;
								}

								>p:last-child {
									border-top-right-radius: 6px;
									border-bottom-right-radius: 6px;
								}

								>.checked {
									background: #00b7ff;
									color: #fff;
								}
							}
						}

						.youhui-content {
							margin-top: 20px;
							padding-bottom: 10px;
							background: rgba(0, 183, 255, 0.1);
							border: 2px solid rgba(0, 183, 255, 0.3);
							border-radius: 10px;

							.lebi,
							.youhuiquan {
								width: 100%;
								display: flex;
								flex-direction: column;

								.name {
									padding: 10px;
									width: calc(100% - 40px);
									display: flex;
									flex-direction: row;
									align-items: baseline;

									>p {
										font-weight: 400;
										font-size: 14px;
										color: #333;
									}

									>p:last-child {
										padding: 0 12px;
										font-weight: 400;
										font-size: 12px;
										color: #333;
									}
								}

								.lebiItem {
									padding: 6px 20px;
									width: calc(100% - 40px);
									display: flex;
									flex-direction: row;
									align-items: center;

									.el-radio__inner {
										width: 20px;
										height: 20px;
									}

									div {
										display: flex;
										flex-direction: row;
										align-items: center;

										>input {
											margin: 0 12px;
											padding: 0 10px;
											width: 128px;
											height: 24px;
											background: #f4f4f4;
											border: 2px solid #00b7ff;
											font-weight: 400;
											font-size: 14px;
											color: #00b7ff;
										}

										>p {
											padding: 0 6px;
											font-weight: 400;
											font-size: 16px;
											color: #333;
										}
									}
								}
							}
						}
					}

					.shifu {
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: flex-end;
						align-items: baseline;

						>p {
							font-weight: 400;
							font-size: 14px;
							color: #F56C6C;
						}

						>p:first-child {
							padding-right: 20px;
							color: #333;
						}

						>p:last-child {
							font-weight: 400;
							font-size: 20px;
							color: #F56C6C;
						}

					}

				}

				.payIng {
					width: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;

					p {
						font-size: 20px;
						color: #67C23A;
					}

					.scanStep {
						padding: 20px 0;
						display: flex;
						flex-direction: row;
						align-items: center;

						p {
							margin: 0 10px;
							font-weight: 400;
							font-size: 16px;
							color: #F56C6C !important;
						}
					}
				}

				.payAfter {
					width: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;

					.status {
						margin-top: 20px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;

						.el-icon-success {
							font-size: 80px;
							color: #0fa784;
						}

						.el-icon-error {
							font-size: 80px;
							color: #f56c6c;
						}

						.el-icon-warning {
							font-size: 80px;
							color: #e6a23c;
						}

						>p {
							padding: 20px;
							font-size: 16px;
							text-align: center;
						}

						.text-success {
							color: #0fa784;
						}

						.text-error {
							color: #f56c6c;
						}

						.text-warning {
							color: #e6a23c;
						}
					}
				}

				.payBefore,
				.payIng,
				.payAfter {
					.btnBox {
						padding: 20px 0 10px;
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: center;
						align-items: center;


						.el-button {
							width: 50%;
							height: 36px;
							border-radius: 36px;
							display: flex;
							flex-direction: row;
							justify-content: center;
							align-items: center;
						}

						.el-button+.el-button {
							margin-left: 20px;
						}

						.cancelBtn {
							background: #FFFFFF;
							border: 1px solid #D6D6D6;
							font-weight: 400;
							font-size: 14px;
							color: #1A1A1A;
						}

						.confirmBtn {
							background: #F56C6C;
							border: 1px solid #F56C6C;
							font-weight: 400;
							font-size: 14px;
							color: #fff;
						}
					}
				}
			}
		}
	}
</style>